import { gql } from '@apollo/client'

export const SEND_CHAT_MESSAGE = gql`
  mutation SendChatMessage(
    $contactId: Int!
    $content: String!
    $channel: String
    $configId: Int
    $fromNumber: String
  ) {
    sendChatMessage(
      contactId: $contactId
      content: $content
      channel: $channel
      configId: $configId
      fromNumber: $fromNumber
    ) {
      messageId
      createdAt
      success
      error
    }
  }
`

export const MARK_AS_READ = gql`
  mutation MarkAsRead($contactId: Int!) {
    markAsRead(contactId: $contactId) {
      success
      updatedCount
    }
  }
`

export const CREATE_TAG = gql`
  mutation CreateTag($name: String!, $color: String!) {
    createTag(name: $name, color: $color) {
      tag {
        id
        name
        color
      }
      success
    }
  }
`

export const MANAGE_CONTACT_TAG = gql`
  mutation ManageContactTag(
    $contactId: Int!
    $tagId: Int!
    $action: String!
  ) {
    manageContactTag(
      contactId: $contactId
      tagId: $tagId
      action: $action
    ) {
      tags {
        id
        name
        color
      }
      success
      error
    }
  }
`
